import React from "react";
import { BuilderContextProvider } from "../../../Components/GMS/Builder/BuilderContext.jsx";
import BuilderDetailManage from "../../../Components/GMS/Builder/BuilderDetailManage.jsx";

function BuilderDetail(props) {
  const { params } = props.match;
  //const search = new URLSearchParams(props?.location?.search ?? "");
  const search = new window.URLSearchParams(props?.location?.search ?? "");
  const builderType = search.get("version");
  return (
    <React.Fragment>
      <BuilderContextProvider>
        <BuilderDetailManage builderId={params.id} builderType={builderType} />
      </BuilderContextProvider>
    </React.Fragment>
  );
}

export default BuilderDetail;
